import { useSelector } from 'react-redux';
import { EntityId } from '@reduxjs/toolkit';
import { dialogLastMessageSelector } from './store/selectors';
import { DialogReducerStateShape } from './store/dialog';

export const useLastMessage = (dialogId: EntityId) => {
  return useSelector<DialogReducerStateShape, ReturnType<typeof dialogLastMessageSelector>>((state) =>
    dialogLastMessageSelector(state, dialogId),
  );
};
